export const HEADER_ANCHOR = "header";
export const HEADER_BANNER_ANCHOR = "header-banner";
export const SUB_NAV_ANCHOR = "sub-nav";
export const CV_SUBMIT_PAGE_ANCHOR = "submit-cv-page";
export const MEGA_NAV_ANCHOR = "mega-nav";
export const MOBILE_MENU_ANCHOR = "mobile-menu";
export const PROFILE_PAGE_ANCHOR = "profile-page";
export const DOWNLOAD_BROCHURE_PAGE_ANCHOR = "download-brochure-page";
